import { render, staticRenderFns } from "./AlertSingleMessage.vue?vue&type=template&id=1c5c1d8c&scoped=true&"
import script from "./AlertSingleMessage.vue?vue&type=script&lang=js&"
export * from "./AlertSingleMessage.vue?vue&type=script&lang=js&"
import style0 from "./AlertSingleMessage.vue?vue&type=style&index=0&id=1c5c1d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c1d8c",
  null
  
)

export default component.exports